/* LIBRARIES */
import { message as antdMessage } from 'antd';
import axios from 'axios';
import isNil from 'lodash/isNil';
import moment from 'moment-timezone';
import { all, call, fork, put, takeLatest } from 'redux-saga/effects';

import { DATE_TIME_FORMAT } from 'constants/time';
import downloadFile, { prepareFilename } from 'utils/download-file';
import { getRequest } from 'utils/redux-saga-requests';

import {
  downloadDevicesAndSamplePointsCSV,
  downloadDevicesAndSamplePointsCSVSuccess
} from './actions';
import ActionTypes from './constants';

// ==============================
// SAGAS
// ==============================
export function* exportDevicesWithSamplePoints(
  action: ReturnType<typeof downloadDevicesAndSamplePointsCSV>
) {
  const {
    payload: { enterpriseId, enterpriseName, apiConnected }
  } = action;

  try {
    let path: string = `device/export?format=csv&enterpriseId=${enterpriseId}`;
    if (!isNil(apiConnected)) {
      path += `&apiConnected=${apiConnected}`;
    }
    const response = yield call(getRequest, path);

    const browserTimezone = moment.tz.guess();
    const safeDateText = moment().tz(browserTimezone).format(DATE_TIME_FORMAT.URI_SAFE);
    const fallbackName = `${enterpriseName.trim()} Devices List - ${safeDateText}.csv`;
    const fileName = prepareFilename(response, fallbackName);

    downloadFile(fileName, response.data, 'text/csv');

    antdMessage.success('Device list exported');
  } catch (error) {
    if (!axios.isAxiosError(error)) throw error;

    antdMessage.error('Failed to export device list');
  } finally {
    yield put(downloadDevicesAndSamplePointsCSVSuccess());
  }
}

// ==============================
// REGISTRATION
// ==============================
export function* watchExportDevicesWithSamplePoints() {
  yield takeLatest(
    ActionTypes.LOAD_CSV_DEVICES_WITH_SAMPLEPOINTS_LIST_REQUEST,
    exportDevicesWithSamplePoints
  );
}

// ==============================
// EXPORT
// ==============================
export default function* exportsSaga() {
  yield all([
    fork(watchExportDevicesWithSamplePoints)
  ]);
}
